<template>
  <div class="container-fluid about">
    <h1>This is an about page</h1>
    <div class="row">
      <div class="col-xs-2">Online</div>
      <div class="col-xs-2">{{ online }}</div>
    </div>
    <ul>
      <li>{{ auth }}</li>
      <li>{{ user }}</li>
    </ul>
    <audio-recorder />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AudioRecorder from '../components/AudioRecorder'

export default {
  components: {
    AudioRecorder
  },
  computed: {
    ...mapGetters({
      auth: 'auth',
      user: 'user',
      online: 'online'
    })
  }
}
</script>